module.exports = __webpack_public_path__ + "static/en-sm-3-3e78390f32a45699968fcc1058be5eb1.png";